import * as authConstants from '../constants/authConstants';
import {
  setLocalStorage, removeLocalStorage
} from '../../helpers/storage';

const storageMiddleware = (store) => (next) => (action) => {
  const { data, type } = action;
  switch (type) {
    case authConstants.AUTHENTICATE_USER_FAILURE:
    case authConstants.LOGOUT_SUCCESS:
      removeLocalStorage("token");
      removeLocalStorage("refreshToken");

      break;
    case authConstants.AUTHENTICATE_USER_SUCCESS:
    case authConstants.LOGIN_SUCCESS:
      setLocalStorage("token", data.token);
      setLocalStorage("refreshToken", data.refreshToken);
      break;
    default:
      break;
  }
  return next(action);
};

export default storageMiddleware;